import StorefrontIcon from "@mui/icons-material/Storefront";
import { Box, Tooltip } from "@mui/material";
import { AccessRoleCodes } from "Models/AccessRoleCodes";
import { Resources, useResource } from "Translations/Resources";
import type { ReactNode } from "react";

/**
 * Storefront marker on a merchant's avatar in social lists — distinguishes business
 * personas from customers (who carry no badge).
 */
export const MerchantAvatarBadge = () => {
  const { t } = useResource();

  return (
    <Tooltip title={t(Resources.Auth.ContextSwitcher.Roles.Merchant)}>
      <Box
        sx={{
          width: 18,
          height: 18,
          borderRadius: "50%",
          bgcolor: "background.paper",
          boxShadow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <StorefrontIcon color="primary" sx={{ fontSize: 12 }} />
      </Box>
    </Tooltip>
  );
};

/** Maps a social DTO's role onto the row's avatar badge slot (merchants only for now). */
export const getSocialAvatarBadge = (
  accessRoleCode: string | null | undefined,
): ReactNode =>
  accessRoleCode === AccessRoleCodes.Merchant ? (
    <MerchantAvatarBadge />
  ) : undefined;
